import React from 'react';

import { PEN_ICON } from '../pen-glyph';
import {
  Body,
  ButtonLabel,
  Hero,
  HeroIcon,
  HeroLine,
  Logo,
  Mail,
  MailButton,
  PaperLine,
  PenIcon,
} from './EmailPicture.styles';

export type EmailPictureProps = {
  /** When the email starts sliding in, in ms from mount. Its button is tapped a beat later. */
  delayMs: number;
};

/**
 * Step 2's picture: the email DocuSign sends, drawn after the real one. Its logo on white, the violet
 * panel with the pen icon, and the Review Document button the step's line names (in the language of
 * the app, which is the language DocuSign writes in). The rest of the copy is lines. The email slides
 * up into view and its button is tapped once. Decorative: the step's own line says what to do.
 */
export const EmailPicture = ({ delayMs }: EmailPictureProps): React.ReactElement => (
  <Mail $delayMs={delayMs} aria-hidden="true">
    <Logo />
    <Hero>
      <HeroIcon>
        <PenIcon viewBox="0 0 24 24" focusable="false">
          <path d={PEN_ICON.pencil} />
          <path d={PEN_ICON.line} />
        </PenIcon>
      </HeroIcon>
      <HeroLine $width={78} />
      <HeroLine $width={54} />
      <MailButton $delayMs={delayMs}>
        <ButtonLabel text="Review Document" />
      </MailButton>
    </Hero>
    <Body>
      <PaperLine $width={36} />
      <PaperLine $width={88} />
      <PaperLine $width={72} />
    </Body>
  </Mail>
);

export default EmailPicture;
